import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from "reactstrap";

const TopLink = (props) => {
    return (
        <a href={props.link}
        >&nbsp;{props.name}&nbsp;</a>
    )
};

export default TopLink;